<template>
  <v-dialog v-model="show">
    <v-card color="secondary">
      <v-card-text class="pt-4">
        <v-alert
          type="warning"
          :icon="icons.warning"
          outlined
        >
          {{ __('unpaidWarningMessage') }}
        </v-alert>
      </v-card-text>
      <v-card-actions
        v-if="showPaymentLink"
        class="pb-6"
      >
        <v-spacer />
        <v-btn
          depressed
          color="primary"
          @click="proceedToPayment()"
        >
          {{ __('proceedToPayment') }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import SblProceedsToPayment from '@/Mixins/SblProceedsToPayment'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      SblProceedsToPayment,
      UsesIcons,
    ],

    props: {
      value: {
        required: true,
        type: Boolean,
      },
    },

    computed: {
      show: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        }
      },
    },
  }
</script>
